import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-search-select-multiple',
  templateUrl: './search-select-multiple.component.html',
  styleUrls: ['./search-select-multiple.component.scss']
})
export class SearchSelectMultipleComponent implements OnInit {
  @Input() public activateSearch = false;
  @Input() public activeFilterValues!: string[];

  @Output() public selectionChanged = new EventEmitter<string[]>();
  
  @ViewChild('searchInput') public searchInput!: ElementRef;

  public displayedColumns: string[] = ['select', 'name'];
  public dataSource = new MatTableDataSource<string>();
  public selection = new SelectionModel<string>(true, []);

  private items$: Observable<string[]> = new Observable<string[]>();

  @Input()
  public get items(): Observable<string[]> { return this.items$; }
  public set items(value: Observable<string[]>) {
    this.items$ = value;
    if (this.items$) {
      this.items$.subscribe((items: string[]) => {
        this.dataSource.data = items.slice().sort((a, b) => a.localeCompare(b));
        this.dataSource.filterPredicate = this.filterData;
      });
    }
  }

  public ngOnInit(): void {
    if (this.activeFilterValues) {
      this.activeFilterValues.forEach(x => this.selection.select(x));
    }
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row));
    }
    this.selectionChanged.emit(this.selection.selected);
  }

  public applyFilter(filterValue: string): void {
    if (filterValue === undefined) {
      return;
    }

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterData(data: any, filter: string): boolean {
    if (!filter || !data) {
      return true;
    }

    return data.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
  }

  public hasFilterSelected(): boolean {
    return this.selection?.selected?.length > 0;
  }

  public clearFilters(): void {
    this.selection = new SelectionModel<string>(true, []);
    this.searchInput.nativeElement.value = '';
    this.dataSource.filter = '';
    this.selectionChanged.emit(this.selection.selected);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public changeSelection(event: any, row: any): void {
    this.selection.toggle(row);
    this.selectionChanged.emit(this.selection.selected);
  }
}
